import type { Layout } from '../../data/types';
import type { GroundPiece } from '../../site/types';
import { damDeckFootprints } from '../../site/damDeck';
import { difference, fromRing } from '../../geo/clip';
import { ensureCCW, ringBounds } from '../../geo/polygon';

/** The Dam owns its top surface. Keep the surrounding terrain, without a second skin
 * at or just below the slab that can flicker against it from a distant camera. */
export function groundWithoutDecks(
  pieces: readonly GroundPiece[],
  layout: Layout
): readonly GroundPiece[] {
  const decks = damDeckFootprints(layout.landmarks).map((ring) => ({
    polygon: fromRing(ensureCCW(ring)),
    box: ringBounds(ring),
  }));
  if (!decks.length) return pieces;
  return pieces.flatMap((piece) => {
    const box = ringBounds(piece.polygon.outer);
    const near = decks.filter(
      ({ box: d }) =>
        d.minX <= box.maxX && d.maxX >= box.minX && d.minY <= box.maxY && d.maxY >= box.minY
    );
    return near.length
      ? difference(
          [piece.polygon],
          near.map((d) => d.polygon)
        ).map((polygon) => ({ ...piece, polygon }))
      : [piece];
  });
}
